'use client';

import { UserRole } from '@/enums/UserRole';
import { useUserInfo } from '@/hooks/userInfo';
import { roleDefaultPath } from '@/utils/rolePermissions';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import Spinner from '../atoms/Spinner';

export default function AuthenticatedHomeRedirect() {
  const router = useRouter();
  const { data: userInfo } = useUserInfo();

  useEffect(() => {
    if (!userInfo?.role) return;

    const nextPath =
      userInfo.role === UserRole.OPERATOR
        ? '/dash/comunicacoes'
        : roleDefaultPath[userInfo.role];

    router.replace(nextPath);
  }, [router, userInfo?.role]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <Spinner />
    </div>
  );
}